<template>
	<div>
		<v-card elevation="0" :style="'background-color:' + $theme.lightBlue">
			<v-card-title style="font-size: large">
				<v-icon size="20" color="black" style="margin-right: 10px">{{ 'mdi-menu-open' }}</v-icon>
				{{ '시술 메뉴 체계 관리' }}
			</v-card-title>
			<v-row>
				<!-- 대메뉴 테이블 -->
				<v-col>
					<v-card elevation="2" class="mb-4">
						<v-card-title>
							대메뉴
							<v-spacer></v-spacer>
							<v-btn color="primary" @click="addMenu(1)">+추가</v-btn>
						</v-card-title>
						<v-data-table
							:headers="headersWithDelete"
							:items="items.level1"
							item-value="code"
							:items-per-page="-1"
							hide-default-footer
							height="500px"
							fixed-header
						>
							<template v-slot:body>
								<draggable v-model="items.level1" tag="tbody" :handle="'.drag-handle'" @end="updateSortOrder(1)">
									<tr
										v-for="item in items.level1"
										:key="item.code"
										@click="selectMenu(item, 1)"
										:class="{ 'highlight-row': selectedItem.levelCode1 === item.code }"
									>
										<td>
											<v-icon small class="drag-handle" @click.stop>mdi-menu</v-icon>
										</td>
										<td>{{ item.code }}</td>
										<td>{{ item.title }}</td>
										<td>
											<v-btn icon @click.stop="deleteItemConfirm(item, 1)">
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</td>
									</tr>
								</draggable>
							</template>
						</v-data-table>
					</v-card>
				</v-col>

				<!-- 중메뉴 테이블 -->
				<v-col>
					<v-card elevation="2" class="mb-4">
						<v-card-title>
							중메뉴
							<v-spacer></v-spacer>
							<v-btn color="primary" @click="addMenu(2)">+추가</v-btn>
						</v-card-title>
						<v-data-table
							:headers="headersWithDelete"
							:items="items.level2"
							item-value="code"
							:items-per-page="-1"
							hide-default-footer
							height="500px"
							fixed-header
						>
							<template v-slot:body>
								<draggable v-model="items.level2" tag="tbody" :handle="'.drag-handle'" @end="updateSortOrder(2)">
									<tr
										v-for="item in items.level2"
										:key="item.code"
										@click="selectMenu(item, 2)"
										:class="{ 'highlight-row': selectedItem.levelCode2 === item.code }"
									>
										<td>
											<v-icon small class="drag-handle" @click.stop>mdi-menu</v-icon>
										</td>
										<td>{{ item.code }}</td>
										<td>{{ item.title }}</td>
										<td>
											<v-btn icon @click.stop="deleteItemConfirm(item, 2)">
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</td>
									</tr>
								</draggable>
							</template>
						</v-data-table>
					</v-card>
				</v-col>

				<!-- 소메뉴 테이블 -->
				<v-col>
					<v-card elevation="2" class="mb-4">
						<v-card-title>
							소메뉴
							<v-spacer></v-spacer>
							<v-btn color="primary" @click="addMenu(3)">+추가</v-btn>
						</v-card-title>
						<v-data-table
							:headers="headersWithDelete"
							:items="items.level3"
							item-value="code"
							:items-per-page="-1"
							hide-default-footer
							height="500px"
							fixed-header
						>
							<template v-slot:body>
								<draggable v-model="items.level3" tag="tbody" :handle="'.drag-handle'" @end="updateSortOrder(3)">
									<tr v-for="item in items.level3" :key="item.code" @click="selectMenu(item, 3)">
										<td>
											<v-icon small class="drag-handle" @click.stop>mdi-menu</v-icon>
										</td>
										<td>{{ item.code }}</td>
										<td>{{ item.title }}</td>
										<td>
											<v-btn icon @click.stop="deleteItemConfirm(item, 3)">
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</td>
									</tr>
								</draggable>
							</template>
						</v-data-table>
					</v-card>
				</v-col>
			</v-row>

			<!-- 시술 목록 선택 팝업 -->
			<MenuClassSelectDialog
				:show="editDialog"
				:items="availableItems"
				:title="dialogTitle"
				okButtonText="저장"
				cancelButtonText="닫기"
				@onOk="addSelectedItemsToMenu"
				@onCancel="resetItem"
			/>

			<MessageDialog
				:show="deleteMessageDialog"
				message="삭제하시겠습니까?"
				:okButton="true"
				cancelButtonText="취소"
				:deleteButton="true"
				deleteButtonText="삭제"
				@onOk="deleteItem"
				@onCancel="deleteMessageDialog = false"
			/>

			<MessageDialog
				:show="alertMessageDialog"
				message="상위 메뉴를 먼저 선택해야 합니다."
				:cancelButton="false"
				@onOk="alertMessageDialog = false"
				@onCancel="alertMessageDialog = false"
			/>

			<MessageDialog :show="workingStateDialog" message="처리중입니다. 잠시만 기다려주세요." :okButton="false" :cancelButton="false" />
		</v-card>
	</div>
</template>

<script>
	import draggable from 'vuedraggable';
	import MenuClassSelectDialog from './MenuClassSelectDialog.vue'; // 팝업 컴포넌트 임포트

	export default {
		name: 'MenuClassList',
		components: {
			draggable,
			MenuClassSelectDialog,
		},
		props: {
			items: {
				default: () => [],
			},
		},
		data() {
			return {
				workingStateDialog: false,
				editDialog: false,
				deleteMessageDialog: false,
				alertMessageDialog: false,
				dialogTitle: '',
				selectedLevel: '',
				selectedItem: {},
				availableItems: [], // 팝업에 표시할 시술 목록
				levelCode1: '',
				levelTitle1: '',
				levelCode2: '',
				levelTitle2: '',
				levelCode3: '',
				levelTitle3: '',
				loaded: false,
				unsubscribeItems: { level1: null, level2: null, level3: null },
			};
		},
		methods: {
			async addMenu(level) {
				this.workingStateDialog = true;

				const levelNames = ['', '대', '중', '소'];

				// 상위 레벨 확인이 필요한 경우
				if (level >= 2) {
					const upperLevel = level - 1;

					if (this[`levelCode${upperLevel}`] == '' || this[`levelTitle${upperLevel}`] == '') {
						this.workingStateDialog = false;
						this.alertMessageDialog = true;
						return;
					}
				}

				// 시술 목록 로드 및 팝업 설정
				const treatments = await this.$database.loadTreatments(level); // 시술 목록 조회

				// 현재 레벨의 기존 항목들
				const currentItems = this.items[`level${level}`];

				const availableItems = treatments.filter(menuItem => {
					return !currentItems.some(currentItem => currentItem.code === menuItem.code);
				});

				this.availableItems = availableItems;
				this.selectedLevel = level;
				this.dialogTitle = `${levelNames[level]}메뉴 체계 추가`;
				this.editDialog = true;
				this.workingStateDialog = false;
			},
			async selectMenu(item, level) {
				// code, title 초기화
				const resetCodeTitleLevels = [1, 2, 3].filter(l => l > level);
				for (const levelKey of resetCodeTitleLevels) {
					this[`levelCode${levelKey}`] = '';
					this[`levelTitle${levelKey}`] = '';
				}

				this[`levelCode${level}`] = item.code;
				this[`levelTitle${level}`] = item.title;
				this.selectedItem = item;
				this.selectedLevel = level;

				if (level <= 2) {
					const lv = level + 1;
					const levelKey = `level${lv}`;

					// 기존 구독 해제
					if (this.unsubscribeItems[levelKey] != null) {
						this.unsubscribeItems[levelKey]();
					}

					// 새로운 구독 등록
					this.unsubscribeItems[levelKey] = this.$database.onTreatmentClassfications(async () => {
						this.loaded = false;
						this.items[levelKey] = await this.$database.loadUnderTreatmentClassfications(item.code, level, [this.levelCode1, this.levelCode2, this.levelCode3]);
						this.loaded = true;
					}, lv);

					// 바로 아래 뎁스의 메뉴는 위에서 세팅. 2개 뎁스 아래의 메뉴들 전부 초기화
					const resetItemLevels = [1, 2, 3].filter(l => l > level + 1);
					for (const levelKey of resetItemLevels) {
						this.items[`level${levelKey}`] = [];
					}
				}
			},
			async addSelectedItemsToMenu(selectedItems) {
				this.workingStateDialog = true;

				const items = selectedItems.map(item => {
					return {
						...item,
						level: this.selectedLevel,
						levelCode1: this.selectedLevel === 1 ? item.code : this.levelCode1,
						levelTitle1: this.selectedLevel === 1 ? item.title : this.levelTitle1,
						levelCode2: this.selectedLevel === 2 ? item.code : this.levelCode2,
						levelTitle2: this.selectedLevel === 2 ? item.title : this.levelTitle2,
						levelCode3: this.selectedLevel === 3 ? item.code : this.levelCode3,
						levelTitle3: this.selectedLevel === 3 ? item.title : this.levelTitle3,
					};
				});

				this.$emit('modifyItem', { items, level: this.selectedLevel });
				this.editDialog = false;
				this.workingStateDialog = false;
			},
			resetItem() {
				this.editDialog = false;
			},
			async deleteItemConfirm(item, level) {
				this.selectedLevel = level;
				this.selectedItem = item;
				this.deleteMessageDialog = true;
			},
			async deleteItem() {
				this.$emit('deleteItem', { item: this.selectedItem, level: this.selectedLevel });
				this.deleteMessageDialog = false;
			},
			async updateSortOrder(level) {
				const list = this.items[`level${level}`];
				for (let i = 0; i < list.length; i++) {
					list[i].sort = i + 1;
					await this.$database.modifyTreatmentClassfication(list[i]);
				}
			},
		},
		computed: {
			headersWithDelete() {
				return [
					{ text: '정렬', value: 'sort', align: 'center', sortable: false },
					{ text: '메뉴코드', value: 'code', align: 'center', sortable: false },
					{ text: '메뉴명', value: 'title', align: 'center', sortable: false },
					{ text: '삭제', value: 'actions', align: 'center', sortable: false },
				];
			},
		},
	};
</script>

<style scoped>
	/* 선택된 행에 하이라이트 스타일 추가 */
	.highlight-row {
		/* color: #fff; */
		background-color: rgb(30, 57, 134, 0.2) !important; /* 하이라이트 색상 */
	}
</style>
